import RealTimePCRPlugin from './RealTimePCRPlugin';

export default RealTimePCRPlugin;
